// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/consumer_personal_data.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/governance/v0/consumer_personal_data.proto.
 */
export const file_squareup_common_governance_v0_consumer_personal_data: GenFile = /*@__PURE__*/
  fileDesc("CjpzcXVhcmV1cC9jb21tb24vZ292ZXJuYW5jZS92MC9jb25zdW1lcl9wZXJzb25hbF9kYXRhLnByb3RvEhZzcXVhcmV1cC5nb3Zlcm5hbmNlLnYwIpQKChRDb25zdW1lclBlcnNvbmFsRGF0YSL7CQoMU2VtYW50aWNUeXBlEg4KCkRPX05PVF9VU0UQABIXChNHT1ZfSURfRkFDSUFMX0lNQUdFEAESGAoUR0VORVJJQ19GQUNJQUxfSU1BR0UQAhIPCgtIQU5EV1JJVElORxADEg0KCUZVTExfTkFNRRAEEhEKDUVNQUlMX0FERFJFU1MQBRIXChNSRVNJREVOVElBTF9BRERSRVNTEAYSEAoMUEhPTkVfTlVNQkVSEAcSDAoIVVNFUk5BTUUQCBIXChNCQU5LX0FDQ09VTlRfTlVNQkVSEAkSFAoQUEFZTUVOVF9DQVJEX1BBThAKEgcKA1NTThALEhMKD1BBU1NQT1JUX05VTUJFUhAMEhoKFkRSSVZFUlNfTElDRU5TRV9OVU1CRVIQDRIICgRJVElOEA4SDgoKQVVUSF9UT0tFThAPEgwKCFBBU1NXT1JEEBASFQoRQkFOS19BQ0NFU1NfVE9LRU4QERIOCgpGSVJTVF9OQU1FEBISDwoLTUlERExFX05BTUUQExINCglMQVNUX05BTUUQFBIXChNTVFJFRVRfT0ZfUkVTSURFTkNFEBUSHAoYUE9TVEFMX0NPREVfT0ZfUkVTSURFTkNFEBYSFQoRQ0lUWV9PRl9SRVNJREVOQ0UQFxIXChNSRUdJT05fT0ZfUkVTSURFTkNFEBgSGAoUQ09VTlRSWV9PRl9SRVNJREVOQ0UQGRIXChNDT0FSU0VfUEhPTkVfTlVNQkVSEBoSDQoJREVWSUNFX0lEEBsSDwoLQ1VTVE9NRVJfSUQQHBIKCgZHRU5ERVIQHRIRCg1EQVRFX09GX0JJUlRIEB4SFgoSQklSVEhfREFZX09GX01PTlRIEB8SDwoLQklSVEhfTU9OVEgQIBIOCgpCSVJUSF9ZRUFSECESBwoDQUdFECISFwoTQkVMSUVGU19PUl9QT0xJVElDUxAjEhcKE0hFQUxUSF9PUl9TRVhVQUxJVFkQJBIVChFFVEhOSUNJVFlfT1JfUkFDRRAlEg0KCUlORkVSRU5DRRAmEhAKDFRPVUNIX0VWRU5UUxAnEg0KCUJBTktfTkFNRRAoEhcKE0JBTktfUk9VVElOR19OVU1CRVIQKRIeChpDT0FSU0VfQkFOS19BQ0NPVU5UX05VTUJFUhAqEhsKF0NPQVJTRV9QQVlNRU5UX0NBUkRfUEFOECsSFAoQVFJBTlNBQ1RJT05fREFURRAsEhYKElRSQU5TQUNUSU9OX0FNT1VOVBAtEhUKEVRSQU5TQUNUSU9OX1BBUlRZEC4SEAoMQ1JFRElUX1NDT1JFEC8SDgoKQ09BUlNFX1NTThAwEhcKE1BSRUNJU0VfR0VPTE9DQVRJT04QMRIWChJDT0FSU0VfR0VPTE9DQVRJT04QMhIOCgpJUF9BRERSRVNTEDMSFwoTVVNFUl9HRU5FUkFURURfVEVYVBA0EhQKEFBFUlNPTl9QU0VVRE9OWU0QNRIYChRJTlNUUlVNRU5UX1BTRVVET05ZTRA2EhQKEERFVklDRV9QU0VVRE9OWU0QNxIMCghDT05UQUNUUxA4EgoKBklOQ09NRRA5EgwKCEVYUEVOU0VTEDoSCgoGQVNTRVRTEDsSEAoMVU5ERVJXUklUSU5HEDwSFAoQQURWRVJUSVNJTkdfREFUQRA9EhcKE1BST0RVQ1RfSU5URVJBQ1RJT04QPkIqCihjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbi5nb3Zlcm5hbmNlLnYw");

/**
 * @generated from message squareup.governance.v0.ConsumerPersonalData
 */
export type ConsumerPersonalData = Message<"squareup.governance.v0.ConsumerPersonalData"> & {
};

/**
 * Describes the message squareup.governance.v0.ConsumerPersonalData.
 * Use `create(ConsumerPersonalDataSchema)` to create a new message.
 */
export const ConsumerPersonalDataSchema: GenMessage<ConsumerPersonalData> = /*@__PURE__*/
  messageDesc(file_squareup_common_governance_v0_consumer_personal_data, 0);

/**
 * @generated from enum squareup.governance.v0.ConsumerPersonalData.SemanticType
 */
export enum ConsumerPersonalData_SemanticType {
  /**
   * @generated from enum value: DO_NOT_USE = 0;
   */
  DO_NOT_USE = 0,

  /**
   * Facial images used for identity verification, such as on a photo of a Government ID document.
   *
   * @generated from enum value: GOV_ID_FACIAL_IMAGE = 1;
   */
  GOV_ID_FACIAL_IMAGE = 1,

  /**
   * Facial images not used for identity verification, such as photographs or videos used in other contexts.
   *
   * @generated from enum value: GENERIC_FACIAL_IMAGE = 2;
   */
  GENERIC_FACIAL_IMAGE = 2,

  /**
   * Handwriting, including a handwritten signature, such as on a photo of a Government ID document.
   *
   * @generated from enum value: HANDWRITING = 3;
   */
  HANDWRITING = 3,

  /**
   * A person's full name.
   *
   * @generated from enum value: FULL_NAME = 4;
   */
  FULL_NAME = 4,

  /**
   * Personal email address (including hashed email address).
   *
   * @generated from enum value: EMAIL_ADDRESS = 5;
   */
  EMAIL_ADDRESS = 5,

  /**
   * Residential postal address.
   *
   * @generated from enum value: RESIDENTIAL_ADDRESS = 6;
   */
  RESIDENTIAL_ADDRESS = 6,

  /**
   * Personal phone number (including hashed phone number): seven (7) digits or more.
   *
   * @generated from enum value: PHONE_NUMBER = 7;
   */
  PHONE_NUMBER = 7,

  /**
   * Username, $Cashtag, social media handle.
   *
   * @generated from enum value: USERNAME = 8;
   */
  USERNAME = 8,

  /**
   * Bank account number (with more than defined by COARSE_BANK_ACCOUNT_NUMBER).
   *
   * @generated from enum value: BANK_ACCOUNT_NUMBER = 9;
   */
  BANK_ACCOUNT_NUMBER = 9,

  /**
   * Payment Card Primary Account Number (PAN) (more than defined by COARSE_PAYMENT_CARD_PAN).
   *
   * @generated from enum value: PAYMENT_CARD_PAN = 10;
   */
  PAYMENT_CARD_PAN = 10,

  /**
   * Social Security Number (SSN)
   *
   * @generated from enum value: SSN = 11;
   */
  SSN = 11,

  /**
   * Passport Number
   *
   * @generated from enum value: PASSPORT_NUMBER = 12;
   */
  PASSPORT_NUMBER = 12,

  /**
   * Driver's License Number
   *
   * @generated from enum value: DRIVERS_LICENSE_NUMBER = 13;
   */
  DRIVERS_LICENSE_NUMBER = 13,

  /**
   * Individual Tax ID Number (ITIN)
   *
   * @generated from enum value: ITIN = 14;
   */
  ITIN = 14,

  /**
   * Authentication tokens and session tokens.
   *
   * @generated from enum value: AUTH_TOKEN = 15;
   */
  AUTH_TOKEN = 15,

  /**
   * Consumer's password/passcode.
   *
   * @generated from enum value: PASSWORD = 16;
   */
  PASSWORD = 16,

  /**
   * Plaid tokens and similar bank account access credentials.
   *
   * @generated from enum value: BANK_ACCESS_TOKEN = 17;
   */
  BANK_ACCESS_TOKEN = 17,

  /**
   * A first name of a person
   *
   * @generated from enum value: FIRST_NAME = 18;
   */
  FIRST_NAME = 18,

  /**
   * A middle name or middle initial of a person
   *
   * @generated from enum value: MIDDLE_NAME = 19;
   */
  MIDDLE_NAME = 19,

  /**
   * A last name of a person (surname)
   *
   * @generated from enum value: LAST_NAME = 20;
   */
  LAST_NAME = 20,

  /**
   * The street name and street number of a consumer's residence, including any additional information about unit/apt/suite/etc.
   *
   * @generated from enum value: STREET_OF_RESIDENCE = 21;
   */
  STREET_OF_RESIDENCE = 21,

  /**
   * Residential ZIP/postal code
   *
   * @generated from enum value: POSTAL_CODE_OF_RESIDENCE = 22;
   */
  POSTAL_CODE_OF_RESIDENCE = 22,

  /**
   * City of residence
   *
   * @generated from enum value: CITY_OF_RESIDENCE = 23;
   */
  CITY_OF_RESIDENCE = 23,

  /**
   * State/Region/Province/County of residence
   *
   * @generated from enum value: REGION_OF_RESIDENCE = 24;
   */
  REGION_OF_RESIDENCE = 24,

  /**
   * Country of residence (e.g. Customer Region/Country Code).
   *
   * @generated from enum value: COUNTRY_OF_RESIDENCE = 25;
   */
  COUNTRY_OF_RESIDENCE = 25,

  /**
   * Personal phone number: up to six (6) digits
   *
   * @generated from enum value: COARSE_PHONE_NUMBER = 26;
   */
  COARSE_PHONE_NUMBER = 26,

  /**
   * Device IDs (including Advertising ID and other unique identifiers that corresponds with an individual's mobile device).
   *
   * @generated from enum value: DEVICE_ID = 27;
   */
  DEVICE_ID = 27,

  /**
   * Customer ID.
   *
   * @generated from enum value: CUSTOMER_ID = 28;
   */
  CUSTOMER_ID = 28,

  /**
   * Gender.
   *
   * @generated from enum value: GENDER = 29;
   */
  GENDER = 29,

  /**
   * Precise Date of Birth (DOB).
   *
   * @generated from enum value: DATE_OF_BIRTH = 30;
   */
  DATE_OF_BIRTH = 30,

  /**
   * The day of the month that a customer was born.
   *
   * @generated from enum value: BIRTH_DAY_OF_MONTH = 31;
   */
  BIRTH_DAY_OF_MONTH = 31,

  /**
   * The month a customer was born.
   *
   * @generated from enum value: BIRTH_MONTH = 32;
   */
  BIRTH_MONTH = 32,

  /**
   * The year a customer was born.
   *
   * @generated from enum value: BIRTH_YEAR = 33;
   */
  BIRTH_YEAR = 33,

  /**
   * The consumer's age.
   *
   * @generated from enum value: AGE = 34;
   */
  AGE = 34,

  /**
   * Information pertaining to an individual's religious beliefs, philosophical beliefs, or union membership.
   *
   * @generated from enum value: BELIEFS_OR_POLITICS = 35;
   */
  BELIEFS_OR_POLITICS = 35,

  /**
   * Information pertaining to an individual's health, sex life, or sexual orientation.
   *
   * @generated from enum value: HEALTH_OR_SEXUALITY = 36;
   */
  HEALTH_OR_SEXUALITY = 36,

  /**
   * Information about an individual's racial or ethnic demographic.
   *
   * @generated from enum value: ETHNICITY_OR_RACE = 37;
   */
  ETHNICITY_OR_RACE = 37,

  /**
   * Inferences.
   *
   * @generated from enum value: INFERENCE = 38;
   */
  INFERENCE = 38,

  /**
   * Touch events on mobile devices. NOTE: individual touch events are quasi-identifiers and should be regarded as pseudonymous, de-identified data by themselves. Sequences of touch events should be considered as equivalent to the data they represent (e.g., touch event sequences for customer identifiers or authentication efforts should be regarded as identifiable and possibly sensitive).
   *
   * @generated from enum value: TOUCH_EVENTS = 39;
   */
  TOUCH_EVENTS = 39,

  /**
   * Bank name.
   *
   * @generated from enum value: BANK_NAME = 40;
   */
  BANK_NAME = 40,

  /**
   * Bank routing number.
   *
   * @generated from enum value: BANK_ROUTING_NUMBER = 41;
   */
  BANK_ROUTING_NUMBER = 41,

  /**
   * Bank account number (coarse): maximum of four (4) digits
   *
   * @generated from enum value: COARSE_BANK_ACCOUNT_NUMBER = 42;
   */
  COARSE_BANK_ACCOUNT_NUMBER = 42,

  /**
   * Coarse Credit Card Primary Account Number (PAN): (a) Last four digits (b) Six digit BIN + last four digits (c) Eight digit BIN + any other two digits.
   *
   * @generated from enum value: COARSE_PAYMENT_CARD_PAN = 43;
   */
  COARSE_PAYMENT_CARD_PAN = 43,

  /**
   * Date of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_DATE = 44;
   */
  TRANSACTION_DATE = 44,

  /**
   * Amount of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_AMOUNT = 45;
   */
  TRANSACTION_AMOUNT = 45,

  /**
   * Sender/Recipient/Merchant of Transaction (e.g. a bank deposit, a purchase, etc.)
   *
   * @generated from enum value: TRANSACTION_PARTY = 46;
   */
  TRANSACTION_PARTY = 46,

  /**
   * Credit scores (e.g., FICO).
   *
   * @generated from enum value: CREDIT_SCORE = 47;
   */
  CREDIT_SCORE = 47,

  /**
   * Last four (4) digits of Social Security Number (SSN).
   *
   * @generated from enum value: COARSE_SSN = 48;
   */
  COARSE_SSN = 48,

  /**
   * Geolocation (precise): location data with a resolution the same or greater than latitude and longitude with three or more decimal places.
   *
   * @generated from enum value: PRECISE_GEOLOCATION = 49;
   */
  PRECISE_GEOLOCATION = 49,

  /**
   * Geolocation (coarse): location data with a resolution the same or less than latitude and longitude with two decimal places.
   *
   * @generated from enum value: COARSE_GEOLOCATION = 50;
   */
  COARSE_GEOLOCATION = 50,

  /**
   * IP Address.
   *
   * @generated from enum value: IP_ADDRESS = 51;
   */
  IP_ADDRESS = 51,

  /**
   * Free-form text fields and similar user-supplied application content (such as payment notes, email messages, text messages, voice transcripts, etc.), or customer support data generated by the user.
   *
   * @generated from enum value: USER_GENERATED_TEXT = 52;
   */
  USER_GENERATED_TEXT = 52,

  /**
   * Tokens used to identify a consumer, such as pseudonyms for Contact information (e.g. a Cash CustomerToken/ or a Fidelius SSN/ITIN token).
   *
   * @generated from enum value: PERSON_PSEUDONYM = 53;
   */
  PERSON_PSEUDONYM = 53,

  /**
   * Tokens used to identify a specific financial instrument (e.g. a Fidelius PAN token or bank account token).
   *
   * @generated from enum value: INSTRUMENT_PSEUDONYM = 54;
   */
  INSTRUMENT_PSEUDONYM = 54,

  /**
   * Tokens used to identify a particular device, such as a customer's phone (e.g. Cash AppToken).
   *
   * @generated from enum value: DEVICE_PSEUDONYM = 55;
   */
  DEVICE_PSEUDONYM = 55,

  /**
   * Such as a list of contacts in the user's phone, address book, or social graph (see the Contact Information (Precise) category).
   *
   * @generated from enum value: CONTACTS = 56;
   */
  CONTACTS = 56,

  /**
   * Information relating to an individual's income, such as salary, commission, investment income, etc.
   *
   * @generated from enum value: INCOME = 57;
   */
  INCOME = 57,

  /**
   * Information relating to an individual's expenses, such as mortgage/rental payments, monthly utilities, debt payments, etc.
   *
   * @generated from enum value: EXPENSES = 58;
   */
  EXPENSES = 58,

  /**
   * Information relating to an individual's assets, such as details on savings accounts, retirement funds, stocks, bonds, and investments.
   *
   * @generated from enum value: ASSETS = 59;
   */
  ASSETS = 59,

  /**
   * Underwriting decisions.
   *
   * @generated from enum value: UNDERWRITING = 60;
   */
  UNDERWRITING = 60,

  /**
   * Advertising data, such as information about the advertisements the user has seen.
   *
   * @generated from enum value: ADVERTISING_DATA = 61;
   */
  ADVERTISING_DATA = 61,

  /**
   * Product Interaction, such as app launches, link/button presses, scrolling information or other information about how the user interacts with the app. (NOTE: If the data contains raw data about the user's touch inputs on mobile, the data will be more sensitive, see TOUCH_EVENTS).
   *
   * @generated from enum value: PRODUCT_INTERACTION = 62;
   */
  PRODUCT_INTERACTION = 62,
}

/**
 * Describes the enum squareup.governance.v0.ConsumerPersonalData.SemanticType.
 */
export const ConsumerPersonalData_SemanticTypeSchema: GenEnum<ConsumerPersonalData_SemanticType> = /*@__PURE__*/
  enumDesc(file_squareup_common_governance_v0_consumer_personal_data, 0, 0);

